import { CheckCircle2 } from 'lucide-react';

import type { ToastNotification } from '../../types/toast-types';

type ToastIconProps = { type: ToastNotification['type'] };

/** Leading icon for a toast. Types without an icon (`default`, critical-summary) render nothing. */
export const ToastIcon = ({ type }: ToastIconProps) => {
  switch (type) {
    case 'success':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <g clipPath="url(#clip0_2969_14311)">
            <path
              d="M6.24984 10.0001L8.74984 12.5001L13.7498 7.50008M18.3332 10.0001C18.3332 14.6025 14.6022 18.3334 9.99984 18.3334C5.39746 18.3334 1.6665 14.6025 1.6665 10.0001C1.6665 5.39771 5.39746 1.66675 9.99984 1.66675C14.6022 1.66675 18.3332 5.39771 18.3332 10.0001Z"
              stroke="#16A34A"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2969_14311">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'destructive':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M10 6.66675V10.0001M10 13.3334H10.0083M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6025 1.66667 10.0001C1.66667 5.39771 5.39763 1.66675 10 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
            stroke="#DC2626"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'warning':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M8.57465 3.33341L1.51632 15.0001C1.37079 15.2584 1.29394 15.5493 1.29394 15.8451C1.29394 16.1409 1.37079 16.4318 1.51632 16.6901C1.66185 16.9484 1.87033 17.1669 2.12049 17.3251C2.37064 17.4834 2.65378 17.5767 2.94299 17.5967H17.0597C17.3489 17.5767 17.632 17.4834 17.8822 17.3251C18.1323 17.1669 18.3408 16.9484 18.4863 16.6901C18.6319 16.4318 18.7087 16.1409 18.7087 15.8451C18.7087 15.5493 18.6319 15.2584 18.4863 15.0001L11.428 3.33341C11.2816 3.07764 11.0726 2.86181 10.8225 2.70616C10.5723 2.55051 10.2896 2.46997 10.0013 2.46997C9.71306 2.46997 9.43037 2.55051 9.18022 2.70616C8.93007 2.86181 8.72105 3.07764 8.57465 3.33341V3.33341Z"
            stroke="#D97706"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 7.5V10.8333"
            stroke="#D97706"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 14.1667H10.0083"
            stroke="#D97706"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'info':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M10 13.3334V10.0001M10 6.66675H10.0083M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6025 1.66667 10.0001C1.66667 5.39771 5.39763 1.66675 10 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
            stroke="#2563EB"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'prominent-success':
      // Large and uncoloured: it takes the card's white text on the solid green surface.
      return <CheckCircle2 className="size-8 shrink-0" aria-hidden />;
    default:
      return null;
  }
};
